<!-- ContentPage 接收一个底部tab，根据底部tab来渲染页面 -->
<!-- 主要是根据type来渲染页面 -->
<template>
    <div class="content-box" v-if="bottomTabObj">
        <!-- general类型 -->
        <GeneralPageView class="child" v-if="bottomTabObj.type == 'general'" :bottomTab="bottomTabObj"
            ref="generalPageView" />
        <!-- single类型 -->
        <SinglePageView class="child" v-else-if="bottomTabObj.type == 'single'" :bottomTab="bottomTabObj" />
        <!-- message类型 -->
        <MessagePageView class="child" v-else-if="bottomTabObj.type == 'message'" :bottomTab="bottomTabObj" />
        <!-- mine类型 -->
        <MinePageView class="child" v-else-if="bottomTabObj.type == 'mine'" :bottomTab="bottomTabObj" />
    </div>
</template>

<script>
import emitter from '@/utils/eventbus'

import GeneralPageView from '@/views/Decoration/View/GeneralPageView.vue'
import SinglePageView from '@/views/Decoration/View/SinglePageView.vue'
import MessagePageView from '@/views/Decoration/View/MessagePageView.vue'
import MinePageView from '@/views/Decoration/View/MinePageView.vue'

export default {
    name: "BottomTabPageView",
    components: {
        GeneralPageView,
        SinglePageView,
        MessagePageView,
        MinePageView
    },
    data() {
        return {
            bottomTabObj: null,
        }
    },
    methods: {
        /**
        * 添加一个组件
        * TODO 给哪个页面添加  需要判断
        */
        handleAddComponent(data) {
            /**
             * 判断类型 general和single
             */
            if (this.bottomTabObj.type == 'general') {
                /**
                 * 1.获取当前的Tab
                 * 2.判断当前的Tab类型
                 *  -> 选中的tab是组件列表类型，添加
                 *  -> 选中的tab是大屏列表类型，不添加
                */
                const tab = this.$refs['generalPageView'].getCurrentTab()
                console.log('当前tab', tab)
                if (tab && tab.type == 'component_list') {
                    this.addComponentToList(data, tab.component_list_config)
                } else {
                    this.$message.warning('当前Tab不是组件列表类型,无法添加组件')
                }
            } else if (this.bottomTabObj.type == 'single') {
                this.addComponentToList(data, this.bottomTabObj.titlebar.component_list_config)
            }
        },
        /**
         * 添加组件到列表
         */
        addComponentToList(componet, component_list_config) {
            /*判断这个组件是否是bottom_list,
                -> 判断组件列表中有没有bottom_list类型的组件,如果有将不再添加
                -> 如果没有，那么将bottom_list组件添加到组件列表的末尾
            */
            if (componet.type.indexOf('bottom_list') == 0) {
                for (var i = component_list_config.length - 1; i >= 0; i--) {
                    if (component_list_config[i].type.indexOf('bottom_list') == 0) {
                        //todo 提示已经存在
                        console.log('已经有一个bottom_list组件，不能再次添加')
                        this.$message.error("底部列表已存在，无法再次添加")
                        return
                    }
                }
            }
            console.log('handleAddComponent', componet, component_list_config)
            const item = JSON.parse(JSON.stringify(componet))
            if (item.type.indexOf('bottom_list') == 0) {
                component_list_config.push(item)
            } else {
                component_list_config.splice(0, 0, item)
            }
            emitter.emit('onComponentChange', item)
        },
        /**
         * 底部组件切换
         */
        onBottomTabChange(bottomtab) {
            // console.log('底部tab切换', bottomtab)
            this.bottomTabObj = null
            setTimeout(() => {
                this.bottomTabObj = bottomtab
            }, 20)
        }
    },
    mounted() {
        //接收底部Tab切换
        emitter.on('onBottomTabChange', this.onBottomTabChange)
        //接收添加组件
        emitter.on("onAddComponent", this.handleAddComponent)
    },
    beforeUnmount() {
        emitter.off('onBottomTabChange')
        emitter.off("onAddComponent")
    }
}
</script>
  
<style scoped lang="less">
.content-box {
    width: 100%;
    height: calc(100% - 50px);
    position: relative;

    .child {
        width: 100%;
        height: 100%;
    }
}
</style>